module.exports = __webpack_public_path__ + "img/84.87ade2d6.webp";